module.exports = __webpack_public_path__ + "img/38_85.62adb87e.png";